/* eslint-disable react-hooks/exhaustive-deps */
import type React from 'react';
import { useState, useEffect } from 'react';

const useSyncedState = <T>(
  initialValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setValue(initialValue);
  }, [JSON.stringify(initialValue)]);

  return [value, setValue];
};

export default useSyncedState;
